import { render, staticRenderFns } from "./BackToPro.vue?vue&type=template&id=1bb4aa22&scoped=true&"
import script from "./BackToPro.vue?vue&type=script&lang=js&"
export * from "./BackToPro.vue?vue&type=script&lang=js&"
import style0 from "./BackToPro.vue?vue&type=style&index=0&id=1bb4aa22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb4aa22",
  null
  
)

export default component.exports